<div class="content" *ngIf="isMspLoaded">
  <div class="container-fluid">
    <div class="page-title license-title">
      <h1>
        <a class="back" (click)="backClicked()"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> BILLING STATEMENT GENERATE
      </h1>
      <div>
          <button type="button" pButton label="Preview" (click)="preview()" [disabled]="!dialogDocInput.DocNo" class="ui-button-danger update"></button>
          <button type="button" pButton label="Save" (click)="showComfirmDialog('Send')" [disabled]="!PreviewSuccess" class="ui-button-danger"></button>
      </div>

    </div>
    <div class="index-content device-detail">
      <div class="header-title">
        <h5>Billing Settings</h5>
      </div>
      <div class="content-info evnets border-t-radius-none" style="margin: 0px;">
        <div class="content-body">
          <div class="row license-detail billing">
            <div class="col-md-6">
              <ul class="info-list">
                <li>
                  <div class="title">Purchase Type</div>
                </li>
                <li>
                  <div class="value">
                    <div class="custome-calendar">
                      <p-select [options]="PaymentTypeOptions" (onChange)="changeSetting();generateMonths(false);" [(ngModel)]="dialogDocInput.PaymentType" [disabled]="dialogDocInputDisabled.PaymentType"></p-select>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="col-md-6">
              <ul class="info-list">
                <li>
                  <div class="title">Test/Free</div>
                </li>
                <li>
                  <div class="value">
                    <div class="form-group">
                      <p-checkbox [(ngModel)]="dialogDocInput.IsFree" [binary]="true" (onChange)="isFreeOnChange($event);changeSetting();" [disabled]="dialogDocInputDisabled.IsFree"></p-checkbox>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="row license-detail billing">
            <div class="col-md-6" *ngIf="dialogDocInput.PaymentType === PaymentTypeIndex.Prepaid">
              <ul class="info-list">
                <li>
                  <div class="title">Quantity (NPM)</div>
                </li>
                <li>
                  <div class="value">
                    <div class="custome-calendar">
                      <p-inputNumber [showButtons]="true" [min]="1" [step]="1" [(ngModel)]="dialogDocInput.Quantity" (onChange)="changeSetting();" [disabled]="dialogDocInputDisabled.Quantity"></p-inputNumber>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="col-md-6" *ngIf="dialogDocInput.PaymentType === PaymentTypeIndex.Monthly">
              <ul class="info-list">
                <li>
                  <div class="title">Month/Year</div>
                </li>
                <li>
                  <div class="value">
                    <div class="custome-calendar">
                      <p-select [options]="monthOptions" [(ngModel)]="dialogDocInput.Month" placeholder="Month" (onChange)="changeSetting();" [disabled]="dialogDocInputDisabled.Month"></p-select>
                      <p-select [options]="yearOptions" [(ngModel)]="dialogDocInput.Year" placeholder="Year" class="year" (onChange)="changeYears($event);changeSetting();" [disabled]="dialogDocInputDisabled.Year"></p-select>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="col-md-6">
              <ul class="info-list">
                <li>
                  <div class="title">Unit Price</div>
                </li>
                <li>
                  <div class="value">
                    <div class="custome-calendar">
                      <p-inputNumber [showButtons]="true" [min]="0.01" [max]="99.99" [step]="0.01" [(ngModel)]="dialogDocInput.UnitPrice" (onChange)="replaceToFixed($event);changeSetting();"
                      [disabled]="dialogDocInputDisabled.UnitPrice"></p-inputNumber>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="row license-detail billing">
            <div class="col-md-6" *ngIf="docType == 0">
              <ul class="info-list">
                  <li>
                    <div class="title">P.O. Number</div>
                  </li>
                  <li>
                    <div class="value">
                      <div class="custome-calendar">
                        <input class="form-control pInputText" pInputText [(ngModel)]="dialogDocInput.DocNo" (onChange)="changeSetting();" [disabled]="dialogDocInputDisabled.DocNo">
                      </div>
                    </div>
                  </li>
              </ul>
            </div>
            <div class="col-md-6"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="index-content device-detail" style="margin: 30px 0 0 0;" *ngIf="show_Doc_Info.BillingInfo">
      <div class="header-title">
        <h5>Billing Info</h5>
      </div>
      <div class="content-info evnets border-t-radius-none" style="margin: 0px;">
        <div class="content-body">
          <div class="row license-detail billing">
            <div class="col-md-6">
              <ul class="info-list">
                <li>
                  <div class="title">Company</div>
                </li>
                <li>
                  <div class="value">{{docDetailInfo.Company}}</div>
                </li>
              </ul>
            </div>
            <div class="col-md-6">
              <ul class="info-list">
                <li>
                  <div class="title">PPC PRO Account</div>
                </li>
                <li>
                  <div class="value">{{docDetailInfo.RegionName}}</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="row license-detail billing" *ngIf="dialogDocInput.PaymentType === PaymentTypeIndex.Monthly">
            <!-- <div class="col-md-6">
              <ul class="info-list">
                <li>
                  <div class="title">Month/Year</div>
                </li>
                <li>
                  <div class="value">{{docDate}}</div>
                </li>
              </ul>
            </div> -->
            <div class="col-md-6">
              <ul class="info-list">
                <li>
                  <div class="title">Statement Period</div>
                </li>
                <li>
                  <div class="value">{{docDetailInfo.Period}}</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="row license-detail billing" *ngIf="dialogDocInput.PaymentType === PaymentTypeIndex.Monthly && docDetailInfo.MinCharge > 0">
            <div class="col-md-6">
              <ul class="info-list">
                <li>
                  <div class="title">Minimum quantity of devices</div>
                </li>
                <li>
                  <div class="value">{{docDetailInfo.MinCharge}}</div>
                </li>
              </ul>
            </div>
            <div class="col-md-6"></div>
          </div>
        </div>
      </div>
    </div>
    <section style="margin: 30px 0 0 0;" *ngIf="show_Doc_Info.Summary">
      <div class="page-filter clearfix border-b-radius-none" style="margin: 0">
        <div class="page-title sub-title">
          <h5 class="float-left">Summary</h5>
        </div>
      </div>
    </section>
    <section style="margin: 0 0 0 0;" *ngIf="show_Doc_Info.Summary">
      <div class="content-info licenseUsedDetail border-t-radius-none" >
        <p-treeTable [value]="summaryList" [columns]="summaryTable_cols">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                {{col.header}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
            <tr>
              <td class="name">
                <div class="inline-flex">
                  <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                  <div class="rowDataName">{{rowData.name}}</div>
                </div>
              </td>
              <td><span *ngIf="rowData.isDefaultQuantity" class="important">*</span> {{rowData.total_quantity}}</td>
              <td>${{rowData.unitprice | number: '1.2-2'}}</td>
              <td>${{rowData.total_amount  | number: '1.2-2'}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td>{{summaryTotal.name}}</td>
              <td></td>
              <td></td>
              <td>${{summaryTotal.amount  | number: '1.2-2'}}</td>
            </tr>
          </ng-template>
        </p-treeTable>
        <p class="note" *ngIf="docDetailInfo.MinCharge > 0"><span>*</span> A minimum quantity of {{docDetailInfo.MinCharge}} devices is required when using PPC PRO. </p>
      </div>
    </section>

    <!-- Device Usage -->
    <section style="margin: 30px 0 0 0;" *ngIf="show_Doc_Info.DeviceUsage">
      <div class="page-filter clearfix border-t-radius-none" style="margin: 0">
        <div class="page-title sub-title">
          <h5 class="float-left">Detail</h5>
        </div>
      </div>
    </section>
    <section style="margin: 0 0 0 0;" *ngIf="show_Doc_Info.DeviceUsage">
      <div class="content-info licenseUsedDetail border-t-radius-none">
        <p-treeTable [value]="deviceUsageList" [columns]="deviceUsageTable_cols">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                {{col.header}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
            <tr>
              <td class="name">
                <div class="inline-flex">
                  <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                  <div class="rowDataName">{{rowData.name}}</div>
                </div>
              </td>
              <td>{{rowData.last_quantity}}</td>
              <td>{{rowData.quantity - rowData.last_quantity}}</td>
              <td>{{rowData.quantity}}</td>
              <!-- <td>{{rowData.unitprice}}</td>
              <td>{{rowData.amount}}</td> -->
            </tr>
          </ng-template>
        </p-treeTable>
      </div>
    </section>
  </div>
</div>

<!-- Confirm -->
<p-dialog header="Confirm" [(visible)]="dialogVisibility.confirm" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog distributeDialog" [baseZIndex]="10000">
  <div class="page-content-body">
   <p *ngIf="docMonthYearIsExist else notExist">Are you sure you want to generate a new Document, there is already an Document (#{{dialogDocInput_No}}) for this year and month?</p>
   <ng-template #notExist>
    <p>Are you sure you want to generate a new Document?</p>
  </ng-template>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="Confirm" class="ui-button-danger" (click)="saveDoc(true);" *ngIf="this.dialogVisibility.sendPDF"></button>
      <button type="button" pButton label="Confirm" class="ui-button-danger" (click)="saveDoc(false)" *ngIf="!this.dialogVisibility.sendPDF"></button>
      <button type="button" pButton (click)="dialogVisibility.confirm=false;" label="Cancel" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>
